import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table, Tabs, Tab } from 'react-bootstrap';

import DropDownInput from './common/DropDownInput.jsx';

export default class MaintenanceCasesComponent extends React.Component {

	constructor(props) {
		super(props);
		this.onTabsChange = this.onTabsChange.bind(this);
	}

	onTabsChange(tabsKey) {
		this.props.resetFileLinks();
		this.props.onCasesTabsChange(tabsKey);
		if (0 === tabsKey) {
			this.props.findProcessingMcases();
		}
		if (1 === tabsKey) {
			this.props.findMcasesByYear(this.props.selectedYear);
		}
	}

	componentDidMount() {
		if (!this.props.selectedYear) {
			let year = new Date().getFullYear().toString();
			this.props.changeSelectedYear(year);
		}
		this.props.findCheckCategories();
	}

	componentWillMount() {
		this.props.resetFileLinks();
		let tab = this.props.mCaseListRequestModel.get('tabsKey');
		if (tab === undefined || tab === null) {
			tab = 0;
		}
		this.props.onCasesTabsChange(tab);
		this.onTabsChange(tab);
	}

	toCreateMaintenancePage() {
		hashHistory.push("/addMaintenanceCase");
	}

	checkBeforeWash(id) {
		this.props.setTarget(id);
		hashHistory.push("/maintenanceCards");
	}

	generateSerialFile(casePk) {
		this.props.generateMaintenanceSerialFileMap(casePk);
	}

	generateCheckFile(casePk) {
		this.props.generateMaintenanceCheckFileMap(casePk);
	}

	generateCheckFile2(casePk) {
		this.props.generateMaintenanceCheckFileMap2(casePk);
	}

	generateCardsFile(casePk) {
		this.props.generateMaintenanceCardsFile(casePk);
	}

	generatePriceFile(casePk) {
		this.props.generateMaintenancePriceFile(casePk);
	}

	generateSummaryFile(casePk) {
		this.props.generateMaintenanceSummaryFile(casePk);
	}

	onCheckFileDownLoad(casePk) {
		//casePk+'' : from num to String
		window.open(this.props.files.get(casePk + ''));
	}

	onCheckFileDownLoad2(casePk) {
		//casePk+'' : from num to String
		window.open(this.props.files2.get(casePk + ''));
	}

	onSerialFileDownLoad(casePk) {
		window.open(this.props.serialFiles.get(casePk + ''));
	}

	onCardsFileDownLoad(casePk) {
		window.open(this.props.cardsFiles.get(casePk + ''));
	}

	onPriceFileDownLoad(casePk) {
		window.open(this.props.priceFiles.get(casePk + ''));
	}

	onSummaryFileDownLoad(casePk) {
		window.open(this.props.summaryFiles.get(casePk + ''));
	}

	hideGenerateBtn(casePk) {
		return this.displayBlock(this.props.files.get(casePk + ''));
	}

	hideGenerateBtn2(casePk) {
		return this.displayBlock(this.props.files2.get(casePk + ''));
	}

	hideSerialBtn(casePk) {
		return this.displayBlock(this.props.serialFiles.get(casePk + ''));
	}
	hideGenerateCardsBtn(casePk) {
		return this.displayBlock(this.props.cardsFiles.get(casePk + ''));
	}

	hideGeneratePriceFileBtn(casePk) {
		return this.displayBlock(this.props.priceFiles.get(casePk + ''));
	}

	hideGenerateSummaryFileBtn(casePk) {
		return this.displayBlock(this.props.summaryFiles.get(casePk + ''));
	}

	hideCardsDownloadLink(casePk) {
		return this.displayNone(this.props.cardsFiles.get(casePk + ''));
	}

	hidePriceFileDownloadLink(casePk) {
		return this.displayNone(this.props.priceFiles.get(casePk + ''));
	}

	hideSummaryFileDownloadLink(casePk) {
		return this.displayNone(this.props.summaryFiles.get(casePk + ''));
	}

	hideDownloadLink(casePk) {
		return this.displayNone(this.props.files.get(casePk + ''));
	}

	hideDownloadLink2(casePk) {
		return this.displayNone(this.props.files2.get(casePk + ''));
	}

	hideSerialFileDownloadLink(casePk) {
		return this.displayNone(this.props.serialFiles.get(casePk + ''));
	}

	displayNone(input) {
		if (input === undefined) {
			return { display: 'none' };
		} else {
			return { display: 'block' };
		}
	}

	displayBlock(input) {
		if (input === undefined) {
			return { display: 'block' };
		} else {
			return { display: 'none' };
		}
	}

	handleDelete(casePk, note) {
		let r = confirm('確認刪除 ' + note + ' ?');
		if (r === true) {
			this.props.handleDelete(casePk);
		}
	}

	render() {

		let roles = this.props.roles.toJS();
		let showCreateLink = (roles.includes("ROLE_MAINTENANCE_CASE_EDIT")) ? '' : 'none';
		let showPricing = (roles.includes("ROLE_MAINTENANCE_CASE_PRICING")) ? '' : 'none';

		let alignCenter = {
			textAlign: "center",
			verticalAlign: "middle"
		}

		/*洗前清點*/
		let toChcekTitile = <th hidden >&nbsp;</th>;
		/*清點表*/
		let checkFileTitle = <th hidden >&nbsp;</th>;
		let checkFileTitle2 = <th hidden >&nbsp;</th>;
		/*維修卡*/
		let checkCardsTitle = <th hidden >&nbsp;</th>;
		/*估算表*/
		let priceFormTitle = <th hidden >&nbsp;</th>;
		let summaryTitle = <th hidden >&nbsp;</th>;
		let serialTitle = <th hidden >&nbsp;</th>;

		let ckbsSize = 'large';
		let checkBtnTitle = '';
		function blank(caseId) { }
		let exportCheckFileButton = blank;
		let exportCheckFileButton2 = blank;
		let exportCheckCardsButton = blank;
		let exportPriceFileButton = blank;
		let exportSummaryButton = blank;
		let exportSerialFileButton = blank;

		let exportCheckButton = (caseId) => (
			<td style={alignCenter}>
				<Button
					bsStyle="primary" bsSize={ckbsSize}
					onClick={(event) => { this.checkBeforeWash(caseId); }}>{checkBtnTitle}
				</Button>
			</td>
		);

		let exportCheckFileButtonTemplate = (casePk) => (
			<td style={alignCenter}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generateCheckFile(casePk); }}
					style={this.hideGenerateBtn(casePk)} >產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onCheckFileDownLoad(casePk); }}
					style={this.hideDownloadLink(casePk)} >下載
				</Button>
			</td>
		);
		let exportCheckFileButton2Template = (casePk) => (
			<td style={alignCenter}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generateCheckFile2(casePk); }}
					style={this.hideGenerateBtn2(casePk)} >產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onCheckFileDownLoad2(casePk); }}
					style={this.hideDownloadLink2(casePk)} >下載
				</Button>
			</td>
		);
		let exportCheckCardsButtonTemplate = (casePk) => (
			<td style={alignCenter}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generateCardsFile(casePk); }}
					style={this.hideGenerateCardsBtn(casePk)}>產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onCardsFileDownLoad(casePk); }}
					style={this.hideCardsDownloadLink(casePk)} >下載
				</Button>
			</td>
		);

		let exportPriceFileButtonTemplate = (casePk) => (
			<td style={{ textAlign: "center", verticalAlign: "middle", display: showPricing }}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generatePriceFile(casePk); }}
					style={this.hideGeneratePriceFileBtn(casePk)}>產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onPriceFileDownLoad(casePk); }}
					style={this.hidePriceFileDownloadLink(casePk)} >下載
				</Button>
			</td>
		);

		let exportSummaryButtonTemplate = (casePk) => (
			<td style={{ textAlign: "center", verticalAlign: "middle", display: showPricing }}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generateSummaryFile(casePk); }}
					style={this.hideGenerateSummaryFileBtn(casePk)}>產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onSummaryFileDownLoad(casePk); }}
					style={this.hideSummaryFileDownloadLink(casePk)} >下載
				</Button>
			</td>
		);

		let exportSerialFileButtonTemplate = (casePk) => (
			<td style={alignCenter}>
				<Button
					bsStyle="info"
					onClick={(event) => { this.generateSerialFile(casePk); }}
					style={this.hideSerialBtn(casePk)} >產生
				</Button>
				<Button
					bsStyle="default"
					onClick={(event) => { this.onSerialFileDownLoad(casePk); }}
					style={this.hideSerialFileDownloadLink(casePk)} >下載
				</Button>
			</td>
		);

		let checkFileTitleContent =
			<th>清點表A&nbsp;
				<a hidden href="doc/download_check_file.html" target="_blank">
					<img src='question.svg' height="15" width="15"
						style={{ display: 'inline' }} alt='清點表說明' />
				</a>
			</th>;

		let checkFileTitle2Content = <th>清點表C&nbsp;</th>;

		let checkCardsTitleContent =
			<th>維修卡&nbsp;
				<a hidden href="doc/download_cards_file.html" target="_blank">
					<img src='question.svg' height="15" width="15"
						style={{ display: 'inline' }} alt='維修卡說明' />
				</a>
			</th>;

		let priceFormTitleContent =
			<th style={{ display: showPricing }} >估算表&nbsp;
				<a hidden href="doc/download_price_form.html" target="_blank">
					<img src='question.svg' height="15" width="15"
						style={{ display: 'inline' }} alt='估算表說明' />
				</a>
			</th>;

		let summaryTitleContent = <th style={{ display: showPricing }} >總表</th>;

		let serialTitleContent =
			<th>序號表&nbsp;
				<a hidden href="doc/download_serial_file.html" target="_blank">
					<img src='question.svg' height="15" width="15" alt="" />
				</a>
			</th>;

		//可洗前清點
		let tabKey = this.props.mCaseListRequestModel.get('tabsKey');
		if (tabKey === 0) {
			toChcekTitile = <th>洗前清點</th>;
			checkBtnTitle = '清點...';
		}

		if (tabKey === 1) {
			checkFileTitle = checkFileTitleContent;
			checkFileTitle2 = checkFileTitle2Content;
			checkCardsTitle = checkCardsTitleContent;
			priceFormTitle = priceFormTitleContent;
			summaryTitle = summaryTitleContent;
			serialTitle = serialTitleContent;

			exportCheckButton = blank;
			exportCheckFileButton = exportCheckFileButtonTemplate;
			exportCheckFileButton2 = exportCheckFileButton2Template;
			exportCheckCardsButton = exportCheckCardsButtonTemplate;
			exportPriceFileButton = exportPriceFileButtonTemplate;
			exportSummaryButton = exportSummaryButtonTemplate;
			exportSerialFileButton = exportSerialFileButtonTemplate;
		}

		let caseStatus = function (statusKey) {
			switch (statusKey) {
				case 'WAITING': return '尚未清點';
				case 'CANCELED': return '已取消';
				case 'CHECKING': return '洗前清點中';
				case 'CHECKED': return '洗前清點完畢';
				case 'MODIFYING': return '修改中';
				case 'REFINED': return '已確認';
				case 'FIXING': return '維修中';
				case 'FIXED': return '完成維修';
				case 'AUDITED': return '完成稽核';
				default: return '';
			}
		}

		let deleteDisplay = (tabKey === 0) ? '' : 'none';

		// 顯示選取年份
		let selectYearDiv = []
		if (tabKey === 1) {
			let currentYear = new Date().getFullYear();
			let yearsOptions = [];
			for (let i = currentYear; i >= 2018; i--) {
				yearsOptions.push({ label: i.toString(), value: i.toString() });
			}

			selectYearDiv = (
				<div>
					<DropDownInput id="selectYear"
						label="選取年份"
						options={yearsOptions}
						selected={[{ label: this.props.selectedYear.toString(), value: this.props.selectedYear.toString() }]}
						onChange={(id, value, label) => {
							this.props.changeSelectedYear(value);
							this.props.findMcasesByYear(value);
						}}
					/>
				</div>
			)
		}

		return (
			<div>
				<span hidden>MaintenanceCasesComponent</span>
				<h4>清點作業管理</h4>
				<div style={{ display: showCreateLink, paddingTop: 10, paddingBottom: 10 }}>
					<Button bsStyle="default" onClick={(event) => {
						this.toCreateMaintenancePage();
					}}>
						<span className="glyphicon glyphicon-plus" style={{ marginRight: 10 }} />建立新清點作業
					</Button>
				</div>
				<Tabs id="mCasesTabs"
					defaultActiveKey={this.props.mCaseListRequestModel.get('tabsKey')}
					animation={false}
					onSelect={this.onTabsChange}>
					<Tab eventKey={0} title='待清點'>
					</Tab>
					<Tab eventKey={1} title='檔案'>
					</Tab>
				</Tabs>
				<div style={{ marginTop: 10 }}>
					{selectYearDiv}
					<Table striped bordered condensed hover>
						<thead>
							<tr>
								<th>訂單編號</th>
								<th>客戶</th>
								<th>Note</th>
								{toChcekTitile}
								{checkFileTitle}
								{checkFileTitle2}
								{checkCardsTitle}
								{priceFormTitle}
								{summaryTitle}
								{serialTitle}
								<th>建立時間</th>
								<th>狀態</th>
								<th style={{ display: deleteDisplay }}>刪除</th>
							</tr>
						</thead>
						<tbody>
							{this.props.mCaseListViewModel.map(
								(item, index) =>
									<tr key={index}>
										<td style={alignCenter}>{item.get('orderId')}</td>
										<td style={alignCenter}>{item.get('customer').get('customerName')}</td>
										<td style={alignCenter}>{item.get('note')}</td>
										{exportCheckButton(item.get('id'))}
										{exportCheckFileButton(item.get('id'))}
										{exportCheckFileButton2(item.get('id'))}
										{exportCheckCardsButton(item.get('id'))}
										{exportPriceFileButton(item.get('id'))}
										{exportSummaryButton(item.get('id'))}
										{exportSerialFileButton(item.get('id'))}
										<td style={alignCenter}>{new Date(item.get('createTime')).toLocaleDateString()}</td>
										<td style={alignCenter}>{caseStatus(item.get('status'))}</td>
										<td style={{ textAlign: 'center', verticalAlign: 'middle', width: 1, display: deleteDisplay }}>
											<Button disabled={!item.get('canDelete')} bsStyle="default" onClick={(event) => {
												this.handleDelete(item.get('id'), item.get('note'));
											}}>
												<span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
												<span style={{ color: '#a94442' }}>Delete</span>
											</Button>
										</td>
									</tr>
							)}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceCasesComponent.jsx